









import { defineComponent } from '@vue/composition-api';
import { PathName } from '@getaccept/lib-shared/src/enums/PathNames';
import GetAcceptLogo from '@getaccept/lib-ui/src/assets/img/getaccept-logo-small.svg';

export default defineComponent({
  components: {
    GetAcceptLogo,
  },
  setup() {
    return {
      PathName,
    };
  },
});
